import { Modal } from 'antd';
import type { ModalFuncProps } from 'antd';
import type { TFunction } from 'i18next';

/**
 * Always set ok/cancel from i18n so buttons never fall back to a mismatched
 * Ant Design locale (e.g. English page + 取消).
 * Callers may still override okText / cancelText in props.
 */
export function localeConfirm(t: TFunction, props: ModalFuncProps) {
  return Modal.confirm({
    okText: t('common.confirm'),
    cancelText: t('common.cancel'),
    ...props,
  });
}

export function localeSuccess(t: TFunction, props: ModalFuncProps) {
  return Modal.success({
    okText: t('common.ok'),
    ...props,
  });
}

export function localeError(t: TFunction, props: ModalFuncProps) {
  return Modal.error({
    okText: t('common.ok'),
    ...props,
  });
}

export function localeWarning(t: TFunction, props: ModalFuncProps) {
  return Modal.warning({
    okText: t('common.ok'),
    ...props,
  });
}
